/**
 * Admin Dashboard Layout
 * Responsive layout with slide-in sidebar on mobile, persistent on lg+
 */

import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../../components/admin/Sidebar';
import TopNav from '../../components/admin/TopNav';
import DashboardHome from './DashboardHome';
import StaffManagement from './StaffManagement';
import ServicesManagement from './ServicesManagement';
import ClientsManagement from './ClientsManagement';
import BookingsManagement from './BookingsManagement';
import LocationsManagement from './LocationsManagement';
import Settings from './Settings';

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {/* Mobile overlay — dims background when sidebar is open */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <TopNav onMenuClick={() => setSidebarOpen(true)} />

        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4 sm:p-6">
          <Routes>
            <Route path="/" element={<Navigate to="home" replace />} />
            <Route path="home" element={<DashboardHome />} />
            <Route path="staff" element={<StaffManagement />} />
            <Route path="services" element={<ServicesManagement />} />
            <Route path="bookings" element={<BookingsManagement />} />
            <Route path="clients" element={<ClientsManagement />} />
            <Route path="locations" element={<LocationsManagement />} />
            <Route path="settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
